import React, { useEffect } from "react";
import articlesStore from "../../../store/articles/ArticlesStore";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getArticles } from "../../../store/articles/ArticlesApi";
import { Button, IconButton, Typography } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import ArticleTagEditor from "../ArticleTagEditor";
import { getPrintgroupsFromStores } from "../../../store/articles/ArticlesHelpers";
import TextFieldDialog from "../../Dialogs/TextFieldDialog";
import { Add } from "@material-ui/icons";
import { useDialog } from "../../Dialogs/DialogProvider";
import withIntl from "../../../utils/withIntl";

function Printgroups(props) {
  const merchantId = Number.parseInt(useParams().merchantId);
  let [printgroups, setPrintgroups] = React.useState(null);
  const [selectedPrintgroup, setSelectedPrintgroup] = React.useState(null);
  const [printgroupsCreated, setPrintgroupsCreated] = React.useState([]);
  const [openDialog, closeDialog] = useDialog();

  const onMenuUpdated = () => {
    if (articlesStore.printgroups != null) {
      setPrintgroups(getPrintgroupsFromStores());
    } else {
      setPrintgroups(null);
    }
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    };
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (printgroups != null) {
        setPrintgroups(null);
      }
      getArticles(merchantId);
    } else if (printgroups == null && articlesStore.printgroups != null) {
      onMenuUpdated();
    }
  }, []);

  printgroupsCreated.forEach((printgroupCreated) => {
    if (printgroups == null) {
      printgroups = [printgroupCreated];
    } else if (!printgroups.includes(printgroupCreated)) {
      printgroups.push(printgroupCreated);
    }
  });

  if (!printgroups) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div>
      <Typography>Alle artikelen die niet gekoppeld zijn, horen bij alle printgroepen.</Typography>
      <div style={{ display: "flex", flexFlow: "wrap" }}>
        <Button
          key={null}
          style={{ margin: "8px 16px" }}
          variant={null === selectedPrintgroup ? "contained" : "outlined"}
          color={"primary"}
          onClick={() => {
            setSelectedPrintgroup(null);
          }}
        >
          Geen Printgroep
        </Button>

        {printgroups.map((printgroup) => (
          <Button
            key={printgroup}
            style={{ margin: "8px 16px" }}
            variant={printgroup === selectedPrintgroup ? "contained" : "outlined"}
            color={"primary"}
            onClick={() => {
              setSelectedPrintgroup(printgroup);
            }}
          >
            {printgroup}
          </Button>
        ))}
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <TextFieldDialog
                  title={props.intl.formatMessage({ id: "add_print_group" })}
                  value={""}
                  open={true}
                  onSubmit={(value) => {
                    closeDialog();
                    value = value.toUpperCase();
                    setPrintgroupsCreated(printgroupsCreated.concat([value]));
                  }}
                />
              ),
            });
          }}
        >
          <Add />
        </IconButton>
      </div>
      <ArticleTagEditor selectedTag={selectedPrintgroup} type={"print_tags"} />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default withIntl(Printgroups);
